import React from 'react'

import './PageError.scss'
import errorIcon from '../../common/img/error-icon.svg'

export function PageError(props) {
  let defaultErrorLines = (
    <div className="error-text-color error-flex-margin">
      <span className="error-description-line">
        Something broke while trying to complete your request.
      </span>
      <span className="error-description-line">Check your internet connection and try again.</span>
    </div>
  )

  let details = null

  if (props.errorDetails && props.errorDetails.code) {
    details = (
      <React.Fragment>
        {defaultErrorLines}
        <span className="error-details-header error-text-color error-flex-margin">
          Error Code: {props.errorDetails.code}
        </span>
      </React.Fragment>
    )
  } else if (props.errorDetails && props.errorDetails.message) {
    details = (
      <div className="error-text-color error-flex-margin">
        <span className="error-description-line">{props.errorDetails.message}</span>
      </div>
    )
  } else {
    details = defaultErrorLines
  }

  return (
    <div className="center-container grey-top-border generic-page-error">
      <div className="flex-column-wrapper flex-center">
        <img src={errorIcon} className="error-icon error-flex-margin" alt="error-symbol" />
        <h2 className="error-text-color error-flex-margin">Whoops. Something went wrong.</h2>
        {details}
      </div>
    </div>
  )
}
